import { Skeleton, Stack } from "@altimateai/lego";

const BAR_COUNT = 30;
// Deterministic pseudo-random heights so the skeleton doesn't flicker on re-render.
const barHeights = Array.from({ length: BAR_COUNT }, (_, i) => 30 + ((i * 53) % 65));

const DatabricksCostChartSkeleton = () => (
  <Stack direction="column" gap="md" className="al-w-full">
    <Stack gap="md" className="al-w-full al-h-[400px] al-p-4">
      <Stack direction="column" gap="md" className="al-justify-between al-py-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="al-h-3 al-w-8" />
        ))}
      </Stack>
      <Stack direction="column" gap="sm" className="al-flex-1">
        <Stack gap="xs" className="al-flex-1 al-items-end al-justify-between">
          {barHeights.map((h, i) => (
            <Skeleton key={i} className="al-flex-1 al-rounded-sm" style={{ height: `${h}%` }} />
          ))}
        </Stack>
        <Stack className="al-justify-between al-pt-2">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="al-h-3 al-w-10" />
          ))}
        </Stack>
      </Stack>
    </Stack>
    <Stack gap="md" className="al-justify-center al-pb-2">
      {Array.from({ length: 4 }).map((_, i) => (
        <Skeleton key={i} className="al-h-3 al-w-20" />
      ))}
    </Stack>
  </Stack>
);

export default DatabricksCostChartSkeleton;
